// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';
import { brandColors, currDataColors } from 'types/colors';

// @mui material components
import Card from '@mui/material/Card';

//  React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

const GREEN_DARK = currDataColors.GREEN_DARK;
const GREEN_LIGHT = currDataColors.GREEN_LIGHT;
const YELLOW_DARK = currDataColors.YELLOW_DARK;
const YELLOW_LIGHT = currDataColors.YELLOW_LIGHT;
const RED_DARK = currDataColors.RED_DARK;
const RED_LIGHT = currDataColors.RED_LIGHT;
function MiniStatisticsCard({
  color,
  title,
  value,
  icon,
  unit,
  backgroundColor,
  backgroundColorSecondary,
  mt,
  labelColor,
  borderColor,
  primary,
}) {
  return (
    <Card
      sx={{
        width: '100%',
        boxShadow: 'none',
        backgroundColor: 'transparent !important',
        marginTop: {
          // xs: mt,
          // md: '0',
          // lg: mt,
        },
      }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        pb={1}
        sx={{ height: '2.8rem' }}>
        <MDBox
          display="flex"
          textAlign="right"
          lineHeight={1.25}
          sx={{ width: '100%', justifyContent: 'space-between', gap: '.7rem' }}>
          <MDBox sx={{ textAlign: 'left' }}>
            <MDTypography
              variant="h6"
              fontWeight="light"
              color="white"
              sx={{
                backgroundColor: backgroundColor,
                padding: '.4rem',
                borderRadius: '.4rem',
                width: '10.5rem',
                fontWeight: primary ? '600' : '400',
                paddingLeft: '1.3rem',
                color: labelColor,
                fontSize: '.9rem',
              }}>
              {title}
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              width: '7.8rem',
              border: `1px solid ${
                // prettier-ignore
                color === 'G' ? GREEN_DARK : color === 'Y' ? YELLOW_DARK : color === 'no-color' ? brandColors.GREY_DARK : RED_DARK
              }`,
              backgroundColor:
                // prettier-ignore
                color === 'G' ? GREEN_LIGHT : color === 'Y' ? YELLOW_LIGHT : color === 'no-color' ? brandColors.GREY_LIGHT : RED_LIGHT,
              borderRadius: '.4rem',
            }}>
            <MDTypography
              variant="h6"
              sx={{
                color:
                  // prettier-ignore
                  color === 'G' ? GREEN_DARK : color === 'Y' ? YELLOW_DARK : color === 'no-color' ? brandColors.BLACK : RED_DARK,
                fontSize: '.9rem',
              }}>
              {value}
            </MDTypography>
            <MDTypography
              variant="h6"
              sx={{
                color:
                  // prettier-ignore
                  color === 'G' ? GREEN_DARK : color === 'Y' ? YELLOW_DARK : color === 'no-color' ? brandColors.BLACK : RED_DARK,
                fontSize: '.8rem',
              }}>
              {unit}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of MiniStatisticsCard
MiniStatisticsCard.defaultProps = {
  color: 'info',
  percentage: {
    color: 'success',
    text: '',
    label: '',
  },
};

// Typechecking props for the MiniStatisticsCard
MiniStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'light',
    'dark',
  ]),
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'error',
      'dark',
      'white',
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default MiniStatisticsCard;
